import { Icon } from '@chakra-ui/react';

export const CustomStampCheckIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M3.5 8.5L6.5 11.5L12.5 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
